import '../../styles/breadcrumbs.scss';

import { Fragment, ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';

export interface BreadcrumbsProps {
  children?: ReactNode;
}

export default function Breadcrumbs(props: BreadcrumbsProps) {
  const [portalReady, setPortalReady] = useState(false);

  useEffect(() => {
    if (document.getElementById('breadcrumbPortal')) {
      setPortalReady(true);
    }
  }, []);

  const breadcrumbs = (
    <div className="govuk-breadcrumbs">
      <ol className="govuk-breadcrumbs__list">{props.children}</ol>
    </div>
  );
  return <>{!portalReady ? breadcrumbs : createPortal(breadcrumbs, document.getElementById('breadcrumbPortal')!)}</>;
}

export interface BreadcrumbItemProps {
  to?: string;
  onClick?: (e: { preventDefault(): void }) => void;
  children?: ReactNode;
}

export function BreadcrumbItem(props: BreadcrumbItemProps) {
  return (
    <li className="govuk-breadcrumbs__list-item">
      {props.to ? (
        <Link className="govuk-breadcrumbs__link" to={props.to} onClick={props.onClick}>
          {props.children}
        </Link>
      ) : props.onClick ? (
        <Link className="govuk-breadcrumbs__link" to="#" onClick={props.onClick}>
          {props.children}
        </Link>
      ) : (
        props.children
      )}
    </li>
  );
}

export const getBreadcrumbsFromURLParam = () => {
  const urlParams = new URLSearchParams(location.search);
  const bcParam = urlParams.get('bc');
  if (!bcParam) return false;
  let breadcrumbs;
  try {
    breadcrumbs = JSON.parse(bcParam);
  } catch {
    try {
      breadcrumbs = JSON.parse(decodeURIComponent(bcParam));
    } catch {
      return false;
    }
  }

  return (
    <>
      {breadcrumbs.map((breadcrumb: { to: string; label: string }, index: number) => (
        <Fragment key={index}>
          <BreadcrumbItem to={breadcrumb.to}>{breadcrumb.label}</BreadcrumbItem>
        </Fragment>
      ))}
    </>
  );
};
